import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox';
import { Check, Minus } from 'lucide-react';

import { cn } from '@/lib/utils';

const variants = {
	default:
		'h-4 w-4 rounded-[var(--r-1)] border border-line-2 bg-surface-input data-checked:border-accent data-checked:bg-accent data-checked:text-accent-fg data-indeterminate:border-accent data-indeterminate:bg-accent data-indeterminate:text-accent-fg',
	overlay:
		'h-5 w-5 rounded-[var(--r-2)] border border-[var(--overlay-chip-line)] bg-[var(--overlay-chip)] text-transparent backdrop-blur-sm hover:border-[var(--overlay-chip-line-hover)] data-checked:border-accent data-checked:bg-accent data-checked:text-accent-fg data-checked:backdrop-blur-none',
};

function Checkbox({
	className,
	indeterminate,
	variant = 'default',
	...props
}: CheckboxPrimitive.Root.Props & {
	indeterminate?: boolean;
	variant?: keyof typeof variants;
}) {
	return (
		<CheckboxPrimitive.Root
			data-slot="checkbox"
			indeterminate={indeterminate}
			className={cn(
				'peer flex shrink-0 items-center justify-center transition-all duration-100 outline-none focus-visible:ring-2 focus-visible:ring-ring/50 data-disabled:cursor-not-allowed data-disabled:opacity-50',
				variants[variant],
				className
			)}
			{...props}
		>
			<CheckboxPrimitive.Indicator className="flex items-center justify-center">
				{indeterminate ? (
					<Minus size={variant === 'overlay' ? 14 : 12} strokeWidth={2.5} />
				) : (
					<Check size={variant === 'overlay' ? 14 : 12} strokeWidth={2.5} />
				)}
			</CheckboxPrimitive.Indicator>
		</CheckboxPrimitive.Root>
	);
}

export { Checkbox };
